import { dm_trang_thai_lead } from "../models/response/category/dm_trang_thai_lead";
import { apiClient } from "./apiClient";

export const TRANG_THAI_LEAD_API_END_POINT = "trang-thai-lead";

export const trangThaiLeadApi = {
    select_by_coso: (dm_coso_id: number) => apiClient.get(`${TRANG_THAI_LEAD_API_END_POINT}?dm_coso_id=${dm_coso_id}`),
    detail: (id: number) => apiClient.get(`${TRANG_THAI_LEAD_API_END_POINT}/${id}`),
    insert: (payload: dm_trang_thai_lead) => apiClient.post(`${TRANG_THAI_LEAD_API_END_POINT}`, payload),
    update: (payload: dm_trang_thai_lead) => apiClient.put(`${TRANG_THAI_LEAD_API_END_POINT}`, payload),
    delete: (id: number) => apiClient.delete(`${TRANG_THAI_LEAD_API_END_POINT}/${id}`)
}
